import { Button } from "@/toggle-ui-kit/button";
import { FileUp } from "lucide-react";

interface ReportListEmptyStateProps {
  onUpload?: () => void;
}

// ============================================
// ReportListEmptyState
// 보고서가 하나도 없을 때 노출되는 빈 상태(일러스트 + 안내 + 업로드).
// 제목은 Heading 2/Medium(20px), 부제는 Label 1/Medium(14px) — Figma 5577:306388.
// ============================================

export const ReportListEmptyState = ({
  onUpload,
}: ReportListEmptyStateProps) => (
  <div className="flex flex-col items-center gap-3 py-20">
    <img src="/illustrations/reports-empty.png" alt="" className="h-40 w-60" />

    {/* Figma: 제목·부제 모두 base/sidebar-foreground(#0a0a0a) */}
    <div className="flex flex-col items-center gap-[3px] text-center text-[#0a0a0a] [font-feature-settings:'ss10'_1]">
      <p className="heading-2-medium">보고서 목록이 비어있습니다.</p>
      <p className="label-1-normal-medium">
        DSD 파일을 업로드하여 DSD 워크북 관리를 시작하세요.
      </p>
    </div>

    <Button
      variant="outlined"
      size="base"
      leftIcon={<FileUp className="size-4" />}
      onClick={onUpload}
      // Figma: 아웃라인 버튼에 shadow/xs
      className="shadow-sm"
    >
      DSD 보고서 업로드
    </Button>
  </div>
);
